export default "__VITE_PUBLIC_ASSET__0ff64fed__"